var {
  useTextField
} = require("@react-aria/textfield");

var {
  useMessageFormatter
} = require("@react-aria/i18n");

var _babelRuntimeHelpersInteropRequireDefault = $parcel$interopDefault(require("@babel/runtime/helpers/interopRequireDefault"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ar-AE.json
var $e098623c5abd86207131f0484ad08121$exports = {};
$e098623c5abd86207131f0484ad08121$exports = JSON.parse("{\"Clear search\":\"مسح البحث\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/bg-BG.json
var $f809dec720e7c26424349d9b2d46bdde$exports = {};
$f809dec720e7c26424349d9b2d46bdde$exports = JSON.parse("{\"Clear search\":\"Изчистване на търсене\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/cs-CZ.json
var $f39fdcc11c18cca380d05ed422ed7$exports = {};
$f39fdcc11c18cca380d05ed422ed7$exports = JSON.parse("{\"Clear search\":\"Vymazat hledání\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/da-DK.json
var $e9c10faa05d161fc8cafbf580e22ea$exports = {};
$e9c10faa05d161fc8cafbf580e22ea$exports = JSON.parse("{\"Clear search\":\"Ryd søgning\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/de-DE.json
var $f4167ea5b036e4ac15c508b1cf59df14$exports = {};
$f4167ea5b036e4ac15c508b1cf59df14$exports = JSON.parse("{\"Clear search\":\"Suche zurücksetzen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/el-GR.json
var $d7e651a69756bedd0a48f04c4979516$exports = {};
$d7e651a69756bedd0a48f04c4979516$exports = JSON.parse("{\"Clear search\":\"Απαλοιφή αναζήτησης\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/en-US.json
var $f20e253760cf5bc2f29783e0efe5d83a$exports = {};
$f20e253760cf5bc2f29783e0efe5d83a$exports = JSON.parse("{\"Clear search\":\"Clear search\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/es-ES.json
var $ef99dd9fe708cf73b353c5f8197b4fb4$exports = {};
$ef99dd9fe708cf73b353c5f8197b4fb4$exports = JSON.parse("{\"Clear search\":\"Borrar búsqueda\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/et-EE.json
var $a59a7e0dfb3f440e2e1e97ce8efc419f$exports = {};
$a59a7e0dfb3f440e2e1e97ce8efc419f$exports = JSON.parse("{\"Clear search\":\"Tühjenda otsing\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/fi-FI.json
var $f290a64a313f77f835a41d6296ad2f2e$exports = {};
$f290a64a313f77f835a41d6296ad2f2e$exports = JSON.parse("{\"Clear search\":\"Tyhjennä haku\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/fr-FR.json
var $b31bed97651267e242d24d6551022ca4$exports = {};
$b31bed97651267e242d24d6551022ca4$exports = JSON.parse("{\"Clear search\":\"Effacer la recherche\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/he-IL.json
var $b8bf653d634ff7703d1050e7604e471$exports = {};
$b8bf653d634ff7703d1050e7604e471$exports = JSON.parse("{\"Clear search\":\"נקה חיפוש\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/hr-HR.json
var $f1891ffa77e96268137169940188a75b$exports = {};
$f1891ffa77e96268137169940188a75b$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/hu-HU.json
var $c38253ddc5536f3a23da97c192b$exports = {};
$c38253ddc5536f3a23da97c192b$exports = JSON.parse("{\"Clear search\":\"Keresés törlése\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/it-IT.json
var $ae5bd8001e6aa93d0004fe7b738d58$exports = {};
$ae5bd8001e6aa93d0004fe7b738d58$exports = JSON.parse("{\"Clear search\":\"Cancella ricerca\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ja-JP.json
var $aefc2841f76847585483f29f024f58e$exports = {};
$aefc2841f76847585483f29f024f58e$exports = JSON.parse("{\"Clear search\":\"検索をクリア\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ko-KR.json
var $ca9c804c7c60f9f4b54a5bdf03e3aab5$exports = {};
$ca9c804c7c60f9f4b54a5bdf03e3aab5$exports = JSON.parse("{\"Clear search\":\"검색 지우기\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/lt-LT.json
var $ad2776f3ca36dd88d43877a2276e33c$exports = {};
$ad2776f3ca36dd88d43877a2276e33c$exports = JSON.parse("{\"Clear search\":\"Išvalyti iešką\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/lv-LV.json
var $e6cac712062558e97d0094b46c66d4$exports = {};
$e6cac712062558e97d0094b46c66d4$exports = JSON.parse("{\"Clear search\":\"Notīrīt meklēšanu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/nb-NO.json
var $b33b6231715f6133acd32dacc5b5b49$exports = {};
$b33b6231715f6133acd32dacc5b5b49$exports = JSON.parse("{\"Clear search\":\"Tøm søk\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/nl-NL.json
var $d61451fa63a769096a98e5af75c10e31$exports = {};
$d61451fa63a769096a98e5af75c10e31$exports = JSON.parse("{\"Clear search\":\"Zoekactie wissen\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/pl-PL.json
var $ad0509fcc7b39e04e72957f6f8a2db1a$exports = {};
$ad0509fcc7b39e04e72957f6f8a2db1a$exports = JSON.parse("{\"Clear search\":\"Wyczyść zawartość wyszukiwania\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/pt-BR.json
var $e933c14bff3961483408c2e5$exports = {};
$e933c14bff3961483408c2e5$exports = JSON.parse("{\"Clear search\":\"Limpar pesquisa\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/pt-PT.json
var $f26435fc24bee6edb1a669189d31d19$exports = {};
$f26435fc24bee6edb1a669189d31d19$exports = JSON.parse("{\"Clear search\":\"Limpar pesquisa\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ro-RO.json
var $c17b0ec1db5334397055294b2a8ef12a$exports = {};
$c17b0ec1db5334397055294b2a8ef12a$exports = JSON.parse("{\"Clear search\":\"Ştergeţi căutarea\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/ru-RU.json
var $f3876d8384793c7f37094f9397b8016$exports = {};
$f3876d8384793c7f37094f9397b8016$exports = JSON.parse("{\"Clear search\":\"Очистить поиск\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sk-SK.json
var $b7970608090e874dab4bdc404ef44023$exports = {};
$b7970608090e874dab4bdc404ef44023$exports = JSON.parse("{\"Clear search\":\"Vymazať vyhľadávanie\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sl-SI.json
var $b396a3efb76f7b09f30f6e7e66867b5$exports = {};
$b396a3efb76f7b09f30f6e7e66867b5$exports = JSON.parse("{\"Clear search\":\"Počisti iskanje\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sr-SP.json
var $f3aa7ff05bada8828401ad3b50cb7$exports = {};
$f3aa7ff05bada8828401ad3b50cb7$exports = JSON.parse("{\"Clear search\":\"Obriši pretragu\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/sv-SE.json
var $e82232fbfea9d7f7e0ab593a7f7a472e$exports = {};
$e82232fbfea9d7f7e0ab593a7f7a472e$exports = JSON.parse("{\"Clear search\":\"Rensa sökning\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/tr-TR.json
var $c8cd6e9b2bd3a9db0d504690f1e$exports = {};
$c8cd6e9b2bd3a9db0d504690f1e$exports = JSON.parse("{\"Clear search\":\"Aramayı temizle\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/uk-UA.json
var $f7a97678369f7cf4c628d1ac54c$exports = {};
$f7a97678369f7cf4c628d1ac54c$exports = JSON.parse("{\"Clear search\":\"Очистити пошук\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/zh-CN.json
var $bc630f8eedd1e90520de8cc0efa6eeb6$exports = {};
$bc630f8eedd1e90520de8cc0efa6eeb6$exports = JSON.parse("{\"Clear search\":\"清除搜索\"}");
// ASSET: /Users/govett/dev/react-spectrum-v3/packages/@react-aria/searchfield/intl/zh-TW.json
var $e251690a4ee68f5d22186ee4854f6d15$exports = {};
$e251690a4ee68f5d22186ee4854f6d15$exports = JSON.parse("{\"Clear search\":\"清除搜尋條件\"}");

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// @ts-ignore
const $bf491a6398f2208b3a1929ee4aa18$var$intlMessages = {
  "ar-AE": _babelRuntimeHelpersInteropRequireDefault($e098623c5abd86207131f0484ad08121$exports).default,
  "bg-BG": _babelRuntimeHelpersInteropRequireDefault($f809dec720e7c26424349d9b2d46bdde$exports).default,
  "cs-CZ": _babelRuntimeHelpersInteropRequireDefault($f39fdcc11c18cca380d05ed422ed7$exports).default,
  "da-DK": _babelRuntimeHelpersInteropRequireDefault($e9c10faa05d161fc8cafbf580e22ea$exports).default,
  "de-DE": _babelRuntimeHelpersInteropRequireDefault($f4167ea5b036e4ac15c508b1cf59df14$exports).default,
  "el-GR": _babelRuntimeHelpersInteropRequireDefault($d7e651a69756bedd0a48f04c4979516$exports).default,
  "en-US": _babelRuntimeHelpersInteropRequireDefault($f20e253760cf5bc2f29783e0efe5d83a$exports).default,
  "es-ES": _babelRuntimeHelpersInteropRequireDefault($ef99dd9fe708cf73b353c5f8197b4fb4$exports).default,
  "et-EE": _babelRuntimeHelpersInteropRequireDefault($a59a7e0dfb3f440e2e1e97ce8efc419f$exports).default,
  "fi-FI": _babelRuntimeHelpersInteropRequireDefault($f290a64a313f77f835a41d6296ad2f2e$exports).default,
  "fr-FR": _babelRuntimeHelpersInteropRequireDefault($b31bed97651267e242d24d6551022ca4$exports).default,
  "he-IL": _babelRuntimeHelpersInteropRequireDefault($b8bf653d634ff7703d1050e7604e471$exports).default,
  "hr-HR": _babelRuntimeHelpersInteropRequireDefault($f1891ffa77e96268137169940188a75b$exports).default,
  "hu-HU": _babelRuntimeHelpersInteropRequireDefault($c38253ddc5536f3a23da97c192b$exports).default,
  "it-IT": _babelRuntimeHelpersInteropRequireDefault($ae5bd8001e6aa93d0004fe7b738d58$exports).default,
  "ja-JP": _babelRuntimeHelpersInteropRequireDefault($aefc2841f76847585483f29f024f58e$exports).default,
  "ko-KR": _babelRuntimeHelpersInteropRequireDefault($ca9c804c7c60f9f4b54a5bdf03e3aab5$exports).default,
  "lt-LT": _babelRuntimeHelpersInteropRequireDefault($ad2776f3ca36dd88d43877a2276e33c$exports).default,
  "lv-LV": _babelRuntimeHelpersInteropRequireDefault($e6cac712062558e97d0094b46c66d4$exports).default,
  "nb-NO": _babelRuntimeHelpersInteropRequireDefault($b33b6231715f6133acd32dacc5b5b49$exports).default,
  "nl-NL": _babelRuntimeHelpersInteropRequireDefault($d61451fa63a769096a98e5af75c10e31$exports).default,
  "pl-PL": _babelRuntimeHelpersInteropRequireDefault($ad0509fcc7b39e04e72957f6f8a2db1a$exports).default,
  "pt-BR": _babelRuntimeHelpersInteropRequireDefault($e933c14bff3961483408c2e5$exports).default,
  "pt-PT": _babelRuntimeHelpersInteropRequireDefault($f26435fc24bee6edb1a669189d31d19$exports).default,
  "ro-RO": _babelRuntimeHelpersInteropRequireDefault($c17b0ec1db5334397055294b2a8ef12a$exports).default,
  "ru-RU": _babelRuntimeHelpersInteropRequireDefault($f3876d8384793c7f37094f9397b8016$exports).default,
  "sk-SK": _babelRuntimeHelpersInteropRequireDefault($b7970608090e874dab4bdc404ef44023$exports).default,
  "sl-SI": _babelRuntimeHelpersInteropRequireDefault($b396a3efb76f7b09f30f6e7e66867b5$exports).default,
  "sr-SP": _babelRuntimeHelpersInteropRequireDefault($f3aa7ff05bada8828401ad3b50cb7$exports).default,
  "sv-SE": _babelRuntimeHelpersInteropRequireDefault($e82232fbfea9d7f7e0ab593a7f7a472e$exports).default,
  "tr-TR": _babelRuntimeHelpersInteropRequireDefault($c8cd6e9b2bd3a9db0d504690f1e$exports).default,
  "uk-UA": _babelRuntimeHelpersInteropRequireDefault($f7a97678369f7cf4c628d1ac54c$exports).default,
  "zh-CN": _babelRuntimeHelpersInteropRequireDefault($bc630f8eedd1e90520de8cc0efa6eeb6$exports).default,
  "zh-TW": _babelRuntimeHelpersInteropRequireDefault($e251690a4ee68f5d22186ee4854f6d15$exports).default
};

/**
 * Provides the behavior and accessibility implementation for a search field.
 * @param props - Props for the search field.
 * @param state - State for the search field, as returned by `useSearchFieldState`.
 * @param inputRef - A ref to the input element.
 */
function useSearchField(props, state, inputRef) {
  let formatMessage = useMessageFormatter($bf491a6398f2208b3a1929ee4aa18$var$intlMessages);
  let {
    isDisabled,
    onSubmit = () => {},
    onClear,
    type = 'search'
  } = props;

  let onKeyDown = e => {
    const key = e.key;

    if (key === 'Enter' || key === 'Escape') {
      e.preventDefault();
    }

    if (isDisabled) {
      return;
    }

    if (key === 'Enter') {
      onSubmit(state.value);
    }

    if (key === 'Escape') {
      state.setValue('');

      if (onClear) {
        onClear();
      }
    }
  };

  let onClearButtonClick = () => {
    state.setValue('');

    if (onClear) {
      onClear();
    }
  };

  let onPressStart = () => {
    // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
    // the input and close the keyboard
    inputRef.current.focus();
  };

  let {
    labelProps,
    inputProps,
    descriptionProps,
    errorMessageProps
  } = useTextField(_babelRuntimeHelpersExtends({}, props, {
    value: state.value,
    onChange: state.setValue,
    onKeyDown,
    type
  }), inputRef);
  return {
    labelProps,
    inputProps: _babelRuntimeHelpersExtends({}, inputProps, {
      // already handled by useSearchFieldState
      defaultValue: undefined
    }),
    clearButtonProps: {
      'aria-label': formatMessage('Clear search'),
      excludeFromTabOrder: true,
      // @ts-ignore
      preventFocusOnPress: true,
      onPress: onClearButtonClick,
      onPressStart
    },
    descriptionProps,
    errorMessageProps
  };
}

exports.useSearchField = useSearchField;
